import React from 'react';
import { Link } from 'react-router-dom';
const slides = [
    {
        title: "Records",
        mobileText: "Record keeping on the go",
        imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1751106886/Screenshot_2025-06-28_at_3.30.37_PM_v8cjp5.png"

    },
    {
        title: "Reports",
        imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1751106810/Screenshot_2025-06-28_at_3.37.59_PM_lr8xwt.png"

    },
    {
        title: "Service providers",
        imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1751129666/Screenshot_2025-06-28_at_9.57.52_PM_nurtwa.png"

    },
    {
        title: "Resources",
        imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1751106704/Screenshot_2025-06-28_at_3.36.17_PM_hcnpp0.png"


    },
    {
        title: "Contracts",
        imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1751107173/Screenshot_2025-06-28_at_3.29.33_PM_zoytg9.png"



      },
      {
        title: "Communities",
        imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1751107274/Screenshot_2025-06-28_at_3.30.45_PM_pf363v.png"



      },
      {
        title: "Communities",
        imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1751107086/Screenshot_2025-06-28_at_3.30.22_PM_e9v6oz.png"


      },
      {
        title: "Communities",
     

        imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1751129663/Screenshot_2025-06-28_at_9.58.36_PM_los8ro.png"

      },

];

const SolutionsGrid = () => {
    return (
        <div className="relative bg-white md:py-8 py-4 px-4 md:px-20">
            <div className='md:px-10'>
                <div className='flex justify-between  '>
                    <h1 className="text-[14px] md:text-[36px] font-bold  text-black md:mb-5">Experience Farmnet App</h1>
                  
                </div>
                <h1 className="text-[10px] md:text-[32px] font-normal md:mb-3 mb-2 text-black" style={{lineHeight:'1.10'}}>
                Farmnet is a mobile app designed to empower farmers by leveraging technology to <b> boost productivity</b>, efficiency, and sustainability. It provides integrated solutions for <b>farm management </b> , real-time monitoring, and data-driven decision-making. Farmnet also supports farmers in improving production practices,  <b>accessing markets, </b>and facilitating secure <b> payments  </b>all in one user-friendly platform.
                </h1>
            </div>
            <h1 className="text-[14px] md:text-[36px] font-bold  text-black  mb-3 md:px-10">SOLUTIONS</h1>

            {/* Grid Layout for the Cards */}
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 md:gap-y-4 gap-y-2  gap-x-2 md:px-10">
                {slides.map((slide, index) => (
                    <div>
                    <div
                        key={index}
                        className=" w-full h-[110px] sm:w-[45%] md:w-[570px] md:h-[336px] rounded-md overflow-hidden relative cursor-pointer"
                    >
                       

                        {/* Centered Image */}
                            <img
                                src={slide.imageUrl}
                                alt={slide.title}
                                className="object-contain rounded-md "
                            />

                        {/* Text Content */}
                

                        <a 
            href="https://play.google.com/store/apps/details?id=com.farmnet.africa&pcampaignid=web_share" 
            target="_blank" 
            rel="noopener noreferrer"
            className="absolute bottom-2 right-0 w-[50px] h-[100px] z-30 cursor-pointer"
          >
          </a>
          
                    </div>
                    <a href={`/experience${index + 1}`} className='flex justify-end'>
        <div className='flex md:gap-2 gap-1 justify-center md:mt-2'>
          <div className="bg-[#2E453D] md:ml-0 ml-2 text-white font-normal md:px-6 px-2 rounded-md md:rounded-[30px] w-[70px] h-[15px] md:w-[150px] md:text-[18px] text-[6px] md:h-[40px] mt-0 md:-mt-[1px] flex justify-between items-center">
            See More
          </div>
          <div className='bg-[#2E453D] w-[15px] h-[15px] md:w-[40px] md:h-[40px] flex justify-center md:mt-0 mr-2 rounded-full'> 
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748783006/Expand_right_gzn0vr.png"
              alt="Arrow"
              className="md:w-6 md:h-6 w-3 h-3 mt-2 md:flex hidden"
            />
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748783006/Expand_right_gzn0vr.png"
              alt="Arrow"
              className="w-2 h-2 mt-1 md:hidden flex"
            /> 
          </div>
        </div>
      </a>
              </div>

                ))}
            </div>
            <div className=" md:px-10">
  <h1 className="text-[18px] md:text-[32px] font-bold mt-8 mb-4 text-black">
    Download App
  </h1>
  <div className="flex flex-row sm:space-x-6 space-x-2  items-center sm:space-y-0">
   <a href="https://play.google.com/store/apps/details?id=com.farmnet.africa&pcampaignid=web_share" alt="none">      <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751889690/google_PLAY-LOGO.WINE_emyxpu.png" className="h-[25px] md:w-[280px] md:h-[180px]" alt="App Store" />      </a>
    <img
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image_scynki.png"
      alt="Google Play"
      className="h-[30px] md:h-[75px] object-contain"
    />
    <img
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image-1_wdvhie.png"
      alt="QR Code"
      className="h-[30px] md:h-[75px] object-contain"
    />
  </div>
</div>
        </div>
    );
};

export default SolutionsGrid;
